
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[league]/matchup-tool",
      function () {
        return require("private-next-pages/[league]/matchup-tool/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[league]/matchup-tool"])
      });
    }
  